import React from "react";
import { TransformationGalleryPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const TransformationGalleryPage: React.FC<Props> = ({ page, onNext }) => {
  return (
    <div className="page page--transformation-gallery">
      <div className="page__container">
        <h2 className="page__question">{page.title}</h2>
        {page.subtitle && <p className="page__subtitle">{page.subtitle}</p>}

        <div className="transformations">
          {page.transformations.map((transformation, index) => (
            <div key={index} className="transformation-card">
              <div className="transformation-card__images">
                <div className="transformation-card__image-wrapper">
                  <img
                    src={transformation.before}
                    alt="Before"
                    className="transformation-card__image"
                  />
                  <span className="transformation-card__label">Before</span>
                </div>
                <div className="transformation-card__image-wrapper">
                  <img
                    src={transformation.after}
                    alt="After"
                    className="transformation-card__image"
                  />
                  <span className="transformation-card__label">After</span>
                </div>
              </div>
              <div className="transformation-card__info">
                <p className="transformation-card__timeframe">
                  {transformation.timeframe}
                </p>
                <p className="transformation-card__result">
                  {transformation.result}
                </p>
              </div>
            </div>
          ))}
        </div>

        <button className="page__button" onClick={onNext}>
          {page.buttonText}
        </button>
      </div>
    </div>
  );
};

export default TransformationGalleryPage;
